import { combineReducers } from '@reduxjs/toolkit';

import AuthReducer from './auth/reducer';
import bigScreenReducer from './bigScreen/reducer';
import DeepLinkReducer from './deepLink/reducer';
import ErrorsReducer from './errors/reducer';
import GuidesReducer from './guides/reducer';
import LoadingReducer from './loading/reducer';
import ModalsReducer from './modals/reducer';
import personalPlanReducer from './personalPlan/reducer';
import sessionReducer from './session/reducer';
import SubscriptionsReducer from './subscriptions/reducer';
import UiReducer from './uiEffects/reducer';
import UserReducer from './user/reducer';

const rootReducer = combineReducers({
    auth: AuthReducer,
    user: UserReducer,
    subscriptions: SubscriptionsReducer,
    guides: GuidesReducer,
    ui: UiReducer,
    loading: LoadingReducer,
    errors: ErrorsReducer,
    deepLink: DeepLinkReducer,
    personalPlan: personalPlanReducer,
    modals: ModalsReducer,
    session: sessionReducer,
    bigScreen: bigScreenReducer,
});

export default rootReducer;
